import { message } from 'antd';
import axios from './axiosConfig';

export const getAllCars = () => async (dispatch) => {

    dispatch({
        type: 'LOADING',
        payload: true
    });

    try {
        const response = await axios.get('/api/cars/getallcars');
        dispatch({
            type: 'GET_ALL_CARS',
            payload: response.data
        });
        dispatch({
            type: 'LOADING',
            payload: false
        });
    } catch (error) {
        console.log(error);
        dispatch({
            type: 'LOADING',
            payload: false
        });
    }

};

export const addCar = (reqObj) => async dispatch => {

    dispatch({
        type: 'LOADING',
        payload: true
    });

    try {
        await axios.post('/api/cars/addcar', reqObj, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        dispatch({
            type: 'LOADING',
            payload: false
        });

        message.success('New car added successfully');

        setTimeout(() => {
            window.location.href = '/admin/cars';
        }, 500);

    } catch (error) {
        console.log(error);

        dispatch({
            type: 'LOADING',
            payload: false,
            error: error.response.data,
        });
    }


};

export const editCar = (id, reqObj) => async dispatch => {
    dispatch({
        type: 'LOADING',
        payload: true
    });

    const config = {
        headers: { 'Content-Type': 'multipart/form-data' },
    };

    try {
        await axios.put(`/api/cars/editcar/${id}`, reqObj, config, {});

        dispatch({
            type: 'LOADING',
            payload: false
        });

        message.success('Car details updated successfully');
        setTimeout(() => {
            window.location.href = '/admin/cars';
        }, 500);

    } catch (error) {
        console.log(error);
        dispatch({
            type: 'LOADING',
            payload: false
        });
    }


};

export const deleteCar = (id) => async dispatch => {

    dispatch({ type: 'LOADING', payload: true });

    try {
        await axios.delete(`/api/cars/deletecar/${id}`);

        dispatch({ type: 'LOADING', payload: false });

        message.success('Car deleted successfully');
        setTimeout(() => {
            window.location.reload();
        }, 500);

    } catch (error) {
        console.log(error);
        dispatch({ type: 'LOADING', payload: false });
    }


};